import Channels from '@/shared/libs/sdk/live/channels';
import { EventBus } from '@/index/plugins/events';

export const bind = (resource, sync, product) => {
  resource.on('sync', sync);
  EventBus.on('unbind', unbind.bind(null, resource, sync, product));
};

const unbind = (resource, sync, product) => {
  if (!(product.resource.constructor.name === Channels.name && product.resource.collection.length)) {
    resource.off('sync', sync);
  }
};
